import { useRef, type FC } from "react";
import SplitTextAnimation from "../split-text-animation";
import { useInView } from "@/hooks/reveal-in-view";
import type { IndividualInvestorsProps } from "@/types";
import { InvestorsTags } from "./investors-tags";

export const IndividualInvestors: FC<IndividualInvestorsProps> = ({title, investors}) => {
	const ref = useRef(null);
	const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });

  return (
    <section className="individualInvestors">
			<div className="wrapper">
				<SplitTextAnimation
					htmlElement={
					<h2 className="individualInvestors--title" ref={ref}>
						{title}
					</h2>
					}
					isInView={isInView}
				/> 
				<InvestorsTags investors={investors} className="individualInvestors--tags" />
			</div>
    </section>
  )
}